<template>
  <div class="top-navigation">
    <div class="nav-left">
      <breadcrumbs :items="breadcrumbItems" />
    </div>
    <div class="nav-right">
      <navigation-option
        :icon="['fal', 'history']"
        label="Navigeringshistorik"
        :is-expandable="true"
        v-model="visible.history"
      ></navigation-option>
      <history-table :visible="visible.history" ref="historyTable" @close="visible.history = false" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import navigationOption from './components/navigationOption.vue'
import historyTable from './components/historyTable.vue'
import breadcrumbs from './components/breadcrumbs.vue'
import Navigation from '@/util/navigation'

export default Vue.extend({
  name: 'top-navigation',
  props: {},
  data() {
    return {
      visible: {
        history: false
      }
    }
  },
  methods: {},
  computed: {
    breadcrumbItems() {
      const navigation = new Navigation(this.$route)
      const items = [
        {
          label: '',
          url: '/',
          icon: ['fas', 'home']
        }
      ]

      if (this.$store.getters.currentTrustSlug) {
        items.push({
          label: this.$store.getters.currentTrustName
        })
      }

      if (navigation) {
        items.push(...navigation.breadcrumbs())
      }

      return items
    }
  },
  components: { navigationOption, historyTable, breadcrumbs }
})
</script>

<style scoped>
.top-navigation {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  color: black;
  padding: 0.5rem 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 11;
  max-height: var(--navigation-total-height);
  height: var(--navigation-total-height);
  min-height: var(--navigation-total-height);
  margin-left: var(--navigation-total-width);
}

.nav-left,
.nav-right {
  flex: 1;
}

.nav-left {
  flex-grow: 2;
  padding-left: 1rem;
  justify-items: flex-start;
}
.nav-right {
  justify-items: flex-end;
}
</style>
